import {
  JobTypeStatus,
  JobMethodStatus,
  JobRepeatStatus,
  JobAwardTypeStatus,
  JobTargetStatus,
} from './type';

// TaskCoupon
export const couponRuleMap = [
  { label: '满减券', id: 1 },
  { label: '折扣券', id: 2 },
  { label: '立减券', id: 3 },
  { label: '运费券', id: 4 },
];
// taskdetail
export const ticketStatusList = [
  { text: '全部', key: 0 },
  { text: '已领取', key: 1 },
  { text: '已核销', key: 2 },
  { text: '已作废', key: 3 },
];
// item activity
export const activityStatusList = [
  { label: '待生效', value: 0 },
  { label: '生效中', value: 1 },
  { label: '已结束', value: 2 },
];
export const statusMap = ['待生效', '生效中', '已结束'];
// item coupon
export const couponRuleEnums = ['', '满减券', '折扣券', '立减券', '运费券'];
export const supportMap = ['所有用户', '新用户'];
// item
export const actionType = {
  add: {
    name: '新建',
    requestUrl: '/saasmerchant/web/marketjob/newMarketJob',
    code: 'add',
  },
  edit: {
    name: '修改',
    requestUrl: '/saasmerchant/web/marketjob/updateMarketJob',
    code: 'edit',
  },
  look: {
    name: '查看',
    code: 'look',
  },
};
// list
export const channelList = [
  { label: '小程序', id: 0, value: 0 },
  { label: 'H5', id: 1, value: 1 },
  { label: 'APP', id: 2, value: 2 },
];
export const typeList = [
  { label: '顺丰老带新', id: JobTypeStatus.SF },
  { label: '复购任务', id: JobTypeStatus.REPURCHASE },
  { label: '意见任务', id: JobTypeStatus.OPINION },
  { label: '企业老带新', id: JobTypeStatus.COMPANY },
  { label: '饭圈老带新', id: JobTypeStatus.GROUP },
  { label: '新客首单任务', id: JobTypeStatus.NEW_CUSTOMER },
  { label: '阶梯任务', id: JobTypeStatus.LADDER },
];
export const distriLimitList = [
  { label: '团餐配送', id: 1, value: 1 },
  { label: '到店自提', id: 2, value: 2 },
];
export const listToMap = (list) => {
  const retObj = {};
  list.forEach((item) => {
    retObj[item.id === undefined ? item.key : item.id] = [
      item.label === undefined ? item.text : item.label,
    ];
  });
  return retObj;
};
export const objectList = [
  { label: '全平台', id: JobTargetStatus.ALL },
  { label: '不限制', id: JobTargetStatus.NO_LIMIT },
  { label: '按城市', id: JobTargetStatus.CITY },
  { label: '按商圈', id: JobTargetStatus.CBD },
  { label: '按企业', id: JobTargetStatus.COMPANY },
  { label: '按用户', id: JobTargetStatus.USER },
  { label: '按饭圈', id: JobTargetStatus.GROUP },
];
export const methodList = [
  { label: '累计方式', id: JobMethodStatus.ADD },
  { label: '连续方式', id: JobMethodStatus.CONTINUITY },
];
export const repeatList = [
  { label: '不重复', id: JobRepeatStatus.NO_REPEAT },
  { label: '重复', id: JobRepeatStatus.REPEAT },
];

export const awardTypeList = [
  { label: '无奖励', id: JobAwardTypeStatus.NO_AWARD },
  { label: '优惠券', id: JobAwardTypeStatus.COUPON },
  { label: '返利金', id: JobAwardTypeStatus.MONEY },
];

export const awardTypeEnum = {
  coupon: 'COUPON',
  awardAmount: 'REBATE',
  noAward: 'NO_AWARD',
};

export const awardTypeEnumType = {
  COUPON: 0,
  REBATE: 1,
  NO_AWARD: 2,
};

export const allTargetColumns = {
  // 0:全平台 1:按城市 2:按商圈 3:按企业 4:按用户 5:按饭圈
  [JobTargetStatus.CITY]: [
    {
      title: '城市',
      dataIndex: 'cityName',
    },
  ],
  [JobTargetStatus.CBD]: [
    {
      title: '商圈',
      dataIndex: 'businessDistrictName',
    },
  ],
  [JobTargetStatus.COMPANY]: [
    {
      title: '企业Id',
      dataIndex: 'companyId',
    },
    {
      title: '企业名称',
      dataIndex: 'companyName',
    },
  ],
  [JobTargetStatus.USER]: [
    {
      title: '企业名称',
      dataIndex: 'companyName',
    },
    {
      title: '姓名',
      dataIndex: 'userName',
    },
    {
      title: '手机号',
      dataIndex: 'userPhone',
    },
  ],
  [JobTargetStatus.GROUP]: [
    {
      title: '饭圈名称',
      dataIndex: 'groupName',
    },
    {
      title: '圈长名称',
      dataIndex: 'userName',
    },
    {
      title: '圈长城市',
      dataIndex: 'cityName',
    },
  ],
};
